
















































































import { Component, mixins, namespace } from 'nuxt-property-decorator'
import { validationMixin } from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import { CONTACTS_API, CONTACTS_FEEDBACK_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import ComponentFormInputText from '~/components/form/input-text.vue'
import ComponentFormTextarea from '~/components/form/textarea.vue'
import ComponentFormButton from '~/components/form/button.vue'
import { PRIVACY_POLICY_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import MixinGeneral from '~/assets/mixins/general'
import MixinRecaptcha from '~/assets/mixins/recaptcha'
import { useRecaptcha } from '~/assets/functions/useRecaptcha'

const pageStore = namespace('page')
const siteStore = namespace('site')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  filters: {
    filterUrl,
  },
  components: {
    ComponentFormInputText,
    ComponentFormTextarea,
    ComponentFormButton,
    ComponentNavigationBreadcrumbs,
    ComponentTypographyH1,
  },
  mixins: [validationMixin],
  validations: {
    feedbackDataPhone: {
      required,
      correct: (val) => !val.includes('_'),
    },
    feedbackDataName: {
      required,
    },
    feedbackDataMessage: {
      required,
    },
    feedbackDataEmail: {
      email,
    },
  },
})
export default class pageContactsIndex extends mixins(
  MixinGeneral,
  MixinRecaptcha
) {
  private async asyncData({
    $axios,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
  }) {
    const response = await $axios.$get(CONTACTS_API)

    return response
  }

  @siteStore.Getter('getOptionsPhoneMask') private getOptionsPhoneMask!: string
  @siteStore.Getter('getApiKeyRecaptchaSiteKey') getApiKeyRecaptchaSiteKey!:
    | string
    | null

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []

  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }

  private PRIVACY_POLICY_PATH = PRIVACY_POLICY_PATH

  private feedbackDataEmail = ''
  private feedbackDataMessage = ''
  private feedbackDataName = ''
  private feedbackDataPhone = ''

  private get feedbackData() {
    return {
      name: this.feedbackDataName,
      email: this.feedbackDataEmail,
      phone: this.feedbackDataPhone,
      message: this.feedbackDataMessage,
    }
  }

  private isLoading = false
  private isSent = false
  private async send() {
    this.isLoading = true

    const recaptchaToken: string | null = await useRecaptcha(
      this.getApiKeyRecaptchaSiteKey
    )

    this.$v.$touch()
    if (!this.$v.$invalid) {
      let response: any | null = null

      if (recaptchaToken) {
        response = await this.$axios.$post(
          CONTACTS_FEEDBACK_API,
          this.feedbackData,
          {
            headers: {
              'X-Captcha-Token': recaptchaToken,
            },
          }
        )
      } else {
        response = await this.$axios.$post(
          CONTACTS_FEEDBACK_API,
          this.feedbackData
        )
      }

      if (response && response.success) {
        this.isSent = true
      }
    }
    this.isLoading = false
  }

  public $style!: IStyle
  private styleGrid!: IStyle
  private styleMobileGrid!: IStyle
  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classButton() {
    return {
      [this.$style.button]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classFeedbackWrapper() {
    return {
      [this.$style.feedbackWrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classPageWrapper() {
    return {
      [this.styleGrid.container]: !this.$device.isMobileOrTablet,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.pageWrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }
}
